import styles from './Custom404.module.scss';
import Icon from 'components/common/Icon';
import Link from 'next/link';
import Button from 'components/common/Button';
import GlobalHeader from 'components/GlobalHeader';

export default function Custom404() {
  return (
    <>
      <GlobalHeader />
      <div className={styles.emptyWrapper}>
        <Icon name="empty" width={96} height={96} />
        <div className={styles.emptyText}>お探しのページは見つかりません</div>
        <Link href="/">
          <a>
            <Button text="ホーム画面へ" />
          </a>
        </Link>
      </div>
    </>
  );
}
